export default __webpack_public_path__ + "static/media/velcro.a167dbed.webp";